import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS, AMPLITUDE_EVENT_SOURCES } from '@utils/analytics/constants';
import { formatPhoneNumber, formatUnderScoreLowerCase } from '@utils/utils';
import { TFunction } from 'i18next';

export function logOtpConfirm(mobileNumber: string, error: string | string[], t: TFunction): void {
  const e = AMPLITUDE_CONSTANTS.authentication.login_failed;
  const errorKey = Array.isArray(error) ? error[0] : error;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.phone_number]: formatPhoneNumber(mobileNumber),
    [e.attributes.failure_message]:
      AMPLITUDE_EVENT_SOURCES.login_error[errorKey] || formatUnderScoreLowerCase(t(`errorCodes.${errorKey}`)),
  });
}

export function logOTPFailed(mobileNumber: string, error: string | string[]): void {
  const e = AMPLITUDE_CONSTANTS.authentication.otp_failed;
  const errorKey = Array.isArray(error) ? error[0] : error;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.phone_number]: formatPhoneNumber(mobileNumber),
    [e.attributes.failure_message]: AMPLITUDE_EVENT_SOURCES.login_error[errorKey],
    [e.attributes.source]: AMPLITUDE_EVENT_SOURCES.login_page_source.login_page,
  });
}

export function logLoginSuccssfull(mobileNumber: string): void {
  const e = AMPLITUDE_CONSTANTS.Login.loginSuccessful;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.phone_number]: mobileNumber,
  });
}
